import * as React from "react";
import { Tooltip } from "primereact/tooltip";
import type { TableColum, GridSchema } from "../interfaces";
import { getColumnsWithoutLastElement } from "./helpers";
import { cn, getValues } from "../../../helpers/Utils";

interface TableHeadProps {
	lastElement?: TableColum;
	template?: GridSchema["template"];
	columns: Record<string, TableColum>;
	dependenceLength: number;
}

export const TableHead = ({ columns, lastElement, template, dependenceLength }: TableHeadProps) => {
	const { groups, ...otherColumns } = columns;

	return (
		<thead>
			<tr>
				{getColumnsWithoutLastElement(otherColumns, lastElement).map((column) => {
					const { name, extra, field } = column;
					const isKey = name === "key";

					return (
						<th
							scope="col"
							key={column?.field?.toString()}
							style={{ whiteSpace: name.length > 40 ? "normal" : "nowrap", minWidth: isKey ? "50px" : "200px" }}
						>
							<span
								className={cn({
									required: column?.required,
								})}
							>
								{isKey ? "#" : name}
							</span>
							{!!extra?.tooltip && (
								<>
									{/* TODO */}
									{/* @ts-ignore */}
									<Tooltip position="top" target={`#${field}`} />
									<span
										id={field}
										className="glyphicon glyphicon-question-sign"
										data-pr-tooltip={extra?.tooltip ?? ""}
									/>
								</>
							)}
						</th>
					);
				})}

				{!!template && !!groups && !!dependenceLength && (
					<>
						{Array.from({ length: dependenceLength }, (_item, index) => (
							<th key={`${template.templateTitle}_${index}`} className="table-template">
								<span>
									{template.templateTitle} {index + 1}
								</span>
								<div style={{ minWidth: "250px" }}>
									{getValues<typeof groups>(groups).map((column) => (
										<div key={column.field} style={{ width: `calc(100% / ${template.columns?.length})` }}>
											<span className={cn({ required: column?.required })}>{column.name}</span>
										</div>
									))}
								</div>
							</th>
						))}
					</>
				)}
				{lastElement && <th scope="col">{lastElement.name}</th>}
				<th aria-label="Редактирование" className="sticky">
					<span className="glyphicon glyphicon-cog" />
				</th>
			</tr>
		</thead>
	);
};
